module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_40.d129377f.jpg";